import * as classnames from 'classnames'
import {List, ListItem} from '@luminopia/react-toolbox/lib/list'
import {ILuminopiaLogoVerticalTheme, LuminopiaLogoVertical} from 'core/components/LuminopiaLogo'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import * as classNames from './Password.css'

interface ITheme extends ILuminopiaLogoVerticalTheme {
  logoContainer?: string
  formContainer?: string
}
interface IProps extends RouteComponentProps<any> {
  /** return value is rendered in the form container */
  renderForm?: (routeProps: RouteComponentProps<any>) => any
  className?: string
  theme?: ITheme
}

/**
 * Standard interface with a Luminopia logo as the header.
 */
class Password extends React.Component<IProps, {}> {
  public render() {
    const { renderForm, theme = {} } = this.props

    const logoTheme = {
      graphic: classnames(theme.graphic, classNames.graphic),
      lettering: classnames(theme.lettering, classNames.lettering),
    }


    return (
      <div className={this.props.className}>
        <div className={theme.formContainer}>
          <LuminopiaLogoVertical theme={logoTheme} />
          <p>Enter your email address and we'll send you details regarding your password, where an active account exists. Please contact us at <a href="mailto:support@luminopia.com"> support@luminopia.com</a> for help.</p>
        </div>
        <div className={theme.formContainer}>
            {renderForm && renderForm(routeProps(this.props))}
        </div>
      </div>
    )
  }
}

export default Password



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/passwordReset/Password.tsx